import { useState } from 'react';
import { CircleCheck, MessageCircle, X } from 'lucide-react';
import api from '../services/api';
import './css/FeedbackWidget.css'

const FeedbackWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(null);

  const subjectOptions = [
    { value: 'suggestion', label: 'Sugestia ulepszenia' },
    { value: 'bug', label: 'Zgłoszenie błędu' },
    { value: 'automation', label: 'Pomysł na automatyzację' },
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!subject || !message.trim()) {
      setError('Please fill in all fields');
      return;
    }

    setIsSubmitting(true);
    setError(null);

    try {
      await api.post('/feedback', { subject, message });
      setSubmitted(true);
      setSubject('');
      setMessage('');
      // Reset after 3 seconds
      setTimeout(() => {
        setSubmitted(false);
      }, 3000);
    } catch (err) {
      console.error('Error submitting feedback:', err);
      setError('Failed to submit feedback. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    setIsOpen(false);
    setError(null);
    if (!submitted) {
      // Keep form data if not submitted
    }
  };

  return (
    <>
      {/* Floating Button */}
      <button 
        className="feedback-widget-btn"
        onClick={() => setIsOpen(true)}
        title="Wyślij opinię"
        aria-label="Wyślij opinię"
      >
        <MessageCircle aria-hidden="true" />
      </button>

      {/* Sliding Panel */}
      <div className={`feedback-panel ${isOpen ? 'open' : ''}`}>
        <div className="feedback-panel-header">
          <h3><MessageCircle aria-hidden="true" /> Wyślij opinię</h3>
          <button className="close-btn" onClick={handleClose} aria-label="Zamknij panel opinii"><X aria-hidden="true" /></button>
        </div>

        <div className="feedback-panel-content">
          {submitted ? (
            <div className="success-message">
              <div className="success-icon"><CircleCheck aria-hidden="true" /></div>
              <h4>Dziękuję!</h4>
              <p>Twoja opinia została pomyślnie przesłana.</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="feedback-subject">Temat wiadomości</label>
                <select
                  id="feedback-subject"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                  required
                >
                  <option value="">Wybierz temat...</option>
                  {subjectOptions.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="feedback-message">Treść wiadomości</label>
                <textarea
                  id="feedback-message"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  placeholder="Opisz swój pomysł, problem lub sugestię..."
                  rows={6}
                  required
                />
              </div>

              {error && <div className="error-text">{error}</div>}

              <button 
                type="submit" 
                className="submit-btn"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Wysyłanie...' : 'Wyślij'}
              </button>
            </form>
          )}
        </div>
      </div>

      {/* Overlay */}
      {isOpen && <div className="feedback-overlay" onClick={handleClose} />}

    </>
  );
};

export default FeedbackWidget;
